var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80814 4.0949L5.70814 7.96158H8.87479L6.97482 4.0949H9.12482L11.0248 7.96158H14.1915L12.2915 4.0949H14.4415L16.3415 7.96158H19.5082L17.6082 4.0949H20.1922C20.8021 4.0949 21.3234 4.31127 21.7562 4.744C22.1889 5.17674 22.4053 5.69806 22.4053 6.30798V18.692C22.4053 19.2994 22.1889 19.8185 21.7562 20.2494C21.3234 20.6802 20.8021 20.8957 20.1922 20.8957H3.80814C3.20081 20.8957 2.6817 20.6849 2.25082 20.2633C1.81993 19.8416 1.60449 19.3289 1.60449 18.725V6.30798C1.60449 5.69806 1.81993 5.17674 2.25082 4.744C2.6817 4.31127 3.20081 4.0949 3.80814 4.0949ZM3.80814 10.1746V18.692H20.1922V10.1746H3.80814Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.4cfbe5b7a317392c63c8b4a40f0b6af2.svg";
export { ForwardRef as ReactComponent };